/*
 *   File : details.js
 *   Author URI : www.evoqins.com
 *   Description :HUF Order details.
 *   Integrations : null
 *   Version : v1.0
 */

/* import packages */
import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/* import components */
import { NavigationHeader } from "../../../Components/Header";
import { SectionTitle } from "../../../Components/Title";
import { toast } from "react-toastify";
import APIService from "../../../Services/api-service";
import { CustomLoader } from "../../../Components/Other";
import { GradientButton } from "../../../Components/Cta";


const ARROW = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" id="arrow-right">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.81066 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H5.81066L10.5303 17.4697C10.8232 17.7626 10.8232 18.2374 10.5303 18.5303C10.2374 18.8232 9.76256 18.8232 9.46967 18.5303L3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967Z" fill="#1C274C" />
    </svg>
);

const HufDetail = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loader, setLoader] = useState(true);
    const [kycData, setKycData] = useState({});
    function _navigateBack() {
        navigate(-1)
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (location.state !== null) {
            _getKYCData(location.state.customer_id)
        }
    }, [location.state])

    // get kyc progress data
    function _getKYCData(customer_id) {
        setLoader(true);
        let url = 'onboarding/kyc/detail';
        let payload = JSON.stringify({
            customer_id
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setKycData(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: 'error'
                })
            }
            setLoader(false);
        })
    }

    const LabelAnswer = (props) => {
        return (
            <Fragment>
                <p className="color-outer-space e-poppins-regular e-font-16 e-font-sm-16-14 line-height-16px mb-2">{props.label}</p>
                <p className="color-black e-poppins-medium e-font-16 e-font-sm-16-14 line-height-22px mb-0 word-break-all">{props.answer}</p>
            </Fragment>
        )
    }

    function _navigateToKYC() {
        navigate('/create-account', {
            state: {
                user_id: location.state.customer_id
            }
        })
    }
    return (
        <Fragment>
            <NavigationHeader type={1}
                title="Uploaded details" />
            <div className="e-fund-order-summary ps-4 pe-lg-5 pe-md-2 pe-2 pt-2">
                <span className="color-black e-poppins-medium e-font-14 mb-sm-4 mb-2 cursor-pointer gap-3 w-auto icon-link icon-link-hover"
                    onClick={_navigateBack}>
                    {ARROW} Back
                </span>
                {
                    loader === true ?
                        <CustomLoader />
                        :
                        <div className="row">
                            {
                                kycData.onboarding_sub_type === "Minor" ?
                                    <div className="col-xl-6">

                                        {/*=================== Minor details ======================= */}
                                        <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">

                                            <SectionTitle title="Minor details" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Name"
                                                        answer={kycData.minor_details.name_on_pan} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Date of birth"
                                                        answer={kycData.minor_details.date_of_birth} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="Gender"
                                                        answer={kycData.minor_details.gender_text} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="PAN"
                                                        answer={kycData.minor_details.minor_pan} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.minor_details.minor_pan_proof)}>View Preview</p>
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="ID Name"
                                                        answer={kycData.minor_details.minor_dob_proof_text} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">ID proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.minor_details.minor_dob_proof)} >View Preview</p>
                                                </div>
                                            </div>

                                        </div>


                                        {/*=================== Guardian details ======================= */}
                                        <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">

                                            <SectionTitle title="Guardian details" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Name"
                                                        answer={kycData.guardian_details.guardian_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Relation"
                                                        answer={kycData.guardian_details.guardian_relation_text} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="PAN number"
                                                        answer={kycData.guardian_details.guardian_pan} />
                                                </div>

                                                <div className="col-6 pt-4">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.guardian_details.guardian_pan_proof)}>View Preview</p>
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Signature</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.guardian_details.guardian_signature)}>View Preview</p>
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="ID Name"
                                                        answer={kycData.guardian_details.guardian_address_proof_text} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">ID proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.guardian_details.guardian_address_proof)}>View Preview</p>
                                                </div>
                                            </div>

                                        </div>

                                        {/*=================== Guardian details ======================= */}
                                        {kycData.kyc_step > 2 && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">

                                            <SectionTitle title="Current Address" />
                                            <div className="row pt-3 mb-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Address"
                                                        answer={`${kycData.address.current_address_line_1}, ${kycData.address.current_address_line_2}`} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Country"
                                                        answer={kycData.address.current_address_country_name} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="State"
                                                        answer={kycData.address.current_address_state_name} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="City"
                                                        answer={kycData.address.current_address_city_name} />
                                                </div>
                                                <div className="col-6 pt-4">
                                                    <LabelAnswer label="Pincode"
                                                        answer={kycData.address.current_address_pincode} />
                                                </div>
                                            </div>

                                            {kycData.address.same_as_correspondence === false && <Fragment>
                                                <p className="color-eerie-black e-poppins-semi-bold e-font-16 line-height-16px mb-3">Permanent Address</p>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <LabelAnswer label="Address"
                                                            answer={`${kycData.address.permanent_address_line_1}, ${kycData.address.permanent_address_line_2}`} />
                                                    </div>
                                                    <div className="col-6">
                                                        <LabelAnswer label="Country"
                                                            answer={kycData.address.permanent_address_country_name} />
                                                    </div>
                                                    <div className="col-6 pt-4">
                                                        <LabelAnswer label="State"
                                                            answer={kycData.address.permanent_address_state_name} />
                                                    </div>
                                                    <div className="col-6 pt-4">
                                                        <LabelAnswer label="City"
                                                            answer={kycData.address.permanent_address_city_name} />
                                                    </div>
                                                    <div className="col-6 pt-4">
                                                        <LabelAnswer label="Pincode"
                                                            answer={kycData.address.permanent_address_pincode} />
                                                    </div>
                                                </div>
                                            </Fragment>}

                                        </div>}


                                        {/*=================== Declarations ======================= */}
                                        {kycData.kyc_step > 3 && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">
                                            <SectionTitle title="Declarations" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Tax payee in India"
                                                        answer={kycData?.declaration?.tax_payer_in_india === true ? "Yes" : "No"} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Politically exposed"
                                                        answer={!kycData?.declaration?.politically_exposed === true ? "Yes" : "No"} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Terms & conditions"
                                                        answer={kycData?.declaration?.terms_and_condition === true ? "Checked" : "Un Checked"} />
                                                </div>
                                            </div>
                                        </div>}

                                        {/*=================== Bank details ======================= */}
                                        {kycData.kyc_step > 4 && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">
                                            <SectionTitle title="Bank details" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Bank name"
                                                        answer={kycData.bank_details?.bank_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Account number"
                                                        answer={kycData.bank_details?.masked_account_number} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Account type"
                                                        answer={kycData.bank_details?.account_type_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="IFSC code"
                                                        answer={kycData.bank_details?.ifsc_code} />
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                    :
                                    <div className="col-xl-6">

                                        {/*=================== PAN details ======================= */}
                                        <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">

                                            <SectionTitle title="PAN details" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        PAN
                                                    </h6>
                                                    <p className="e-font-16 e-poppins-medium line-height-16px color-light-black my-0">
                                                        {kycData.pan_details?.pan}
                                                    </p>
                                                </div>
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        DOB
                                                    </h6>
                                                    <p className="e-font-16 e-poppins-medium line-height-16px color-light-black my-0">
                                                        {kycData.pan_details?.date_of_birth_str}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/*===================  co-pacarcner details ======================= */}
                                        {kycData.kyc_step > 1 && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">
                                            <SectionTitle title="First applicant & co-pacarcner details" />
                                            <div className="row">
                                                <p className="color-outer-space e-poppins-regular e-font-14 line-height-14px margin-12px-bottom mt-2">Personal details</p>
                                                <div className="col-6">
                                                    <LabelAnswer label="Karta name"
                                                        answer={kycData.huf_info?.karta_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Karta PAN"
                                                        answer={kycData.huf_info?.karta_pan} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Date of birth"
                                                        answer={kycData.huf_info?.karta_dob} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Email"
                                                        answer={kycData.huf_info?.karta_email} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Mobile"
                                                        answer={kycData.huf_info?.karta_mobile} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData?.karta_pan_url)}>View Preview</p>
                                                </div>
                                                <p className="color-jett-black e-poppins-medium e-font-16 margin-12px-bottom mt-4">Address details</p>
                                                <div className="col-6">
                                                    <LabelAnswer label="Address"
                                                        answer={`${kycData.huf_info?.karta_address_line_1} ${kycData.huf_info?.karta_address_line_2 ?? ""} ${kycData.huf_info?.karta_address_line_3 ?? ""}`} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="City"
                                                        answer={kycData.huf_info?.karta_city} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="State"
                                                        answer={kycData.huf_info?.karta_state} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Pincode"
                                                        answer={kycData.huf_info?.karta_pincode} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Address proof"
                                                        answer="Electricity bill" />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Proof</p>
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData?.karta_proof_url)}>View Preview</p>
                                                </div>
                                            </div>
                                            <p className="color-jett-black e-poppins-medium e-font-16 margin-12px-bottom mt-3 pt-1">Added coparcener details</p>
                                            {
                                                kycData.huf_info?.coparcener.map((item) => {
                                                    return (
                                                        <div className="row">
                                                            <p className="color-outer-space e-poppins-regular e-font-14 line-height-14px margin-12px-bottom">Personal details</p>
                                                            <div className="col-6">
                                                                <LabelAnswer label="coparcener name"
                                                                    answer={item.coparcener_name} />
                                                            </div>
                                                            <div className="col-6">
                                                                <LabelAnswer label="coparcener PAN"
                                                                    answer={item.coparcener_pan} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="Date of birth"
                                                                    answer={item.coparcener_dob} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="Email"
                                                                    answer={item.coparcener_email} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="Mobile"
                                                                    answer={item.coparcener_mobile} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">PAN proof</p>
                                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                                    onClick={() => window.open(item.coparcener_pan_url)}>View Preview</p>

                                                            </div>
                                                            <p className="color-jett-black e-poppins-medium e-font-16 margin-12px-bottom mt-4">Address details</p>
                                                            <div className="col-6">
                                                                <LabelAnswer label="Address"
                                                                    answer={`${item.coparcener_address_line_1} ${item.coparcener_address_line_2 ?? ""} ${item.coparcener_address_line_3 ?? ""}`} />
                                                            </div>
                                                            <div className="col-6">
                                                                <LabelAnswer label="City"
                                                                    answer={item.coparcener_city} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="State"
                                                                    answer={item.coparcener_state} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="Pincode"
                                                                    answer={item.coparcener_pincode} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <LabelAnswer label="Address proof"
                                                                    answer={item.coparcener_proof_type} />
                                                            </div>
                                                            <div className="col-6 mt-3">
                                                                <p className="color-outer-space e-poppins-regular e-font-16 line-height-16px mb-2">Proof</p>
                                                                <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                                    onClick={() => window.open(item.coparcener_proof_url)}>View Preview</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>}

                                        {/*=================== Declarations ======================= */}
                                        {kycData.kyc_step > 3 && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">
                                            <SectionTitle title="Declarations" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Tax payee in India"
                                                        answer={kycData?.declaration?.tax_payer_in_india === true ? "Yes" : "No"} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Politically exposed"
                                                        answer={!kycData?.declaration?.politically_exposed === true ? "Yes" : "No"} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Terms & conditions"
                                                        answer={kycData?.declaration?.terms_and_condition === true ? "Checked" : "Un Checked"} />
                                                </div>
                                            </div>
                                        </div>}

                                        {/*=================== Bank details ======================= */}
                                        {kycData.kyc_step > 4 && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">
                                            <SectionTitle title="Bank details" />
                                            <div className="row pt-4">
                                                <div className="col-6">
                                                    <LabelAnswer label="Bank name"
                                                        answer={kycData.bank_details?.bank_name} />
                                                </div>
                                                <div className="col-6">
                                                    <LabelAnswer label="Account number"
                                                        answer={kycData.bank_details?.masked_account_number} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="Account type"
                                                        answer={kycData.bank_details?.account_type_text} />
                                                </div>
                                                <div className="col-6 mt-3">
                                                    <LabelAnswer label="IFSC code"
                                                        answer={kycData.bank_details?.ifsc_code} />
                                                </div>
                                            </div>
                                        </div>}

                                        {/*=================== HUF form ======================= */}
                                        {kycData.signup_progress_text === "ADMIN_VERIFICATION" && <div className="bg-light-sky-blue p-3 border-radius-8px mb-3">
                                            <SectionTitle title="AOF, FATCA, & UBO declaration" />
                                            {kycData.karta_kyc_form_url !== null && <div className="row pt-4">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        KYC form of karta
                                                    </h6>

                                                </div>
                                                <div className="col-6">
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.karta_kyc_form_url)}>View Form</p>
                                                </div>
                                            </div>}

                                            {/* {kycData.coparcener_kyc_form_url !== null && <div className="row pt-2">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        KYC form of coparcener
                                                    </h6>
                                                </div>
                                                <div className="col-6">
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.coparcener_kyc_form_url)}>View Form</p>
                                                </div>
                                            </div>} */}

                                            {kycData.bse_form_url !== null && <div className="row pt-2">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        Account Opening Form (BSE/AOF)
                                                    </h6>
                                                </div>
                                                <div className="col-6">
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.bse_form_url)}>View Form</p>
                                                </div>
                                            </div>}

                                            {/* {kycData.bse_form_url !== null && <div className="row pt-2">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        Non-individual KYC (BSE AOF)
                                                    </h6>
                                                </div>
                                                <div className="col-6">
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.bse_form_url)}>View Form</p>
                                                </div>
                                            </div>} */}

                                            {kycData.ubo_form_url !== null && <div className="row pt-2">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        FATCA/UBO
                                                    </h6>
                                                </div>
                                                <div className="col-6">
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.ubo_form_url)}>View Form</p>
                                                </div>
                                            </div>}

                                            {kycData.non_ind_coparcener_form_url !== null && <div className="row pt-2">
                                                <div className="col-6">
                                                    <h6 className="color-outer-space e-font-16 e-poppins-regular line-height-16px mb-2">
                                                        Non-individual coparcener
                                                    </h6>
                                                </div>
                                                <div className="col-6">
                                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                                        onClick={() => window.open(kycData.non_ind_coparcener_form_url)}>View Form</p>
                                                </div>
                                            </div>}
                                        </div>}
                                    </div>
                            }
                            {
                                kycData.onboarding_sub_type === "Minor" ?
                                    (kycData.kyc_step < 5 || (kycData?.signup_progress_text === "ADMIN_REJECTED" || kycData?.signup_progress_text === "KYC_REJECTED")) && <div className="col-4 text-md-end ">
                                        <GradientButton label={kycData.kyc_step <= 0 ? "Create KYC" : (kycData?.signup_progress_text === "ADMIN_REJECTED" || kycData?.signup_progress_text === "KYC_REJECTED") ? "Resubmit KYC" : "Resume KYC"}
                                            onPress={_navigateToKYC}
                                            className="me-2" />
                                    </div>
                                    :
                                    (kycData.kyc_step <= 10 || (kycData?.signup_progress_text === "ADMIN_REJECTED" || kycData?.signup_progress_text === "KYC_REJECTED")) && <div className="col-4 text-md-end ">
                                        <GradientButton label={kycData.kyc_step <= 0 ? "Create KYC" : (kycData?.signup_progress_text === "ADMIN_REJECTED" || kycData?.signup_progress_text === "KYC_REJECTED") ? "Resubmit KYC" : "Resume KYC"}
                                            onPress={_navigateToKYC}
                                            className="me-2" />
                                    </div>}
                        </div>
                }
            </div>
        </Fragment>

    )

}

export default HufDetail;
